<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center">Tales of Nevèrÿon</h1>
<blockquote>
<p class="noind" style="margin-top:20px;">And if the assumption of responsibility for one’s own discourse leads to the conclusion that all conclusions are genuinely provisional and therefore inconclusive, that all origins are similarly unoriginal, that responsibility itself must cohabit with frivolity, this need not be a cause for gloom … Derrida, then, is asking us to change certain habits of mind: the authority of the text is provisional, the origin is a trace, contradicting logic, we must learn to use and erase our language at the same time … If one is always bound by one’s perspective, one can at least deliberately reverse perspectives as often as possible, in the process undoing opposed perspectives, showing that the two terms of an opposition are merely accomplices of each other …: the notion that the setting up of unitary opposites is an instrument and a consequence of ‘making equal,’ and the dissolving of opposites is the philosopher’s gesture against that will to power which would mystify her very self.</p>
</blockquote>
<p class="right">—<span class="small">GAYATRI CHAKRAVORTY SPIVAK</span></p>
<p class="right">Translator’s Introduction, <i>Of Grammatology</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 7-part.vue?53158374